module.exports = __webpack_public_path__ + "img/home_bg_ecuador.01fc3c7a.jpg";